import { render, staticRenderFns } from "./KaiButton.vue?vue&type=template&id=f25f9884&scoped=true&"
import script from "./KaiButton.vue?vue&type=script&lang=js&"
export * from "./KaiButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25f9884",
  null
  
)

export default component.exports